import { render, staticRenderFns } from "./ResRadioGroup.vue?vue&type=template&id=31ccfb4e&scoped=true"
import script from "./ResRadioGroup.vue?vue&type=script&lang=js"
export * from "./ResRadioGroup.vue?vue&type=script&lang=js"
import style0 from "./ResRadioGroup.vue?vue&type=style&index=0&id=31ccfb4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ccfb4e",
  null
  
)

export default component.exports